import auth from "../../middlewares/auth";
export const textBookSettingsRoute = [
    {
        path: '/settings/text-books',
        component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/textBook/TextBookList'),
        name: 'settings_textbook_list',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/settings/text-books/add',
        component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/textBook/TextBookForm'),
        name: 'settings_textbook_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/settings/text-books/edit/:id',
        component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/textBook/TextBookForm'),
        name: 'settings_textbook_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    }
];